<template>
    <b-modal @hidden="cancel" ref="reminderModal" v-model="modalShow" size="lg"
             hide-footer centered title="Edit Reminder">
        <b-form>
            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Title"
                    label-for="">
                <b-input name="title" :value="reminder.title" v-model="form.title" v-validate="'required'"></b-input>
                <span class="error">{{ errors.first('title') }}</span>
            </b-form-group>

            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Date"
                    label-for="">
                <datepicker v-validate="'required'" name="reminder_date_time" format="yyyy-MM-dd"
                            placeholder="yyyy-mm-dd" v-model="form.reminder_date_time"
                            :value="reminder.reminder_date_time" input-class="form-control"></datepicker>
                <span class="error">{{ errors.first('reminder_date_time') }}</span>
            </b-form-group>

            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Notes"
                    label-for="">
                <b-form-textarea :rows="3" v-validate="'required'" name="notes"
                                 v-model="form.notes" v-text="reminder.notes"></b-form-textarea>
                <span class="error">{{ errors.first('notes') }}</span>
            </b-form-group>

            <b-row class="mt-5">
                <b-col>
                    <b-button @click="handleComplete" class="pull-left" variant="outline-success" v-if="canComplete">
                        <i class="dripicons-lock"></i> Complete
                    </b-button>
                    <b-button @click="handleDelete" class="pull-left" variant="outline-danger">
                        <i class="dripicons-cross"></i>Delete
                    </b-button>
                </b-col>
                <b-col col lg="6" class="text-right">
                    <b-button @click="save"
                              class="btn btn-orange ">
                        <i class="dripicons-checkmark"></i> Save
                    </b-button>
                    <b-button @click="cancel"
                              class="btn btn-default">
                        <i class="dripicons-cross"></i> Cancel
                    </b-button>
                </b-col>
            </b-row>

        </b-form>
    </b-modal>
</template>

<script>
  import {mapActions} from 'vuex';
  import * as REMINDER from '@/store/constants/reminder';

  import Datepicker from 'vuejs-datepicker';

  // mixins
  import AuthUser from '@/mixins/authenticated-user';

  export default {
    inject: ['$validator'],
    props: {
      modalShow: {
        type: Boolean,
        default: false
      },
      reminder: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        form: {}
      };
    },
    components: {Datepicker},
    mixins: [AuthUser],
    computed: {
      canComplete() {
        return this.reminder.status === 'pending';
      }
    },
    methods: {
      ...mapActions({
        updateReminder: REMINDER.ACTION_UPDATE,
        deleteReminder: REMINDER.ACTION_DELETE
      }),

      save() {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.updateReminder(this.form).then(() => {
              this.$emit('updated', true);
              this.form = {};
            }).catch(err => console.log(err));
          }
        });
      },

      cancel() {
        this.$emit('cancelUpdate', true);
      },

      handleComplete() {
        this.updateReminder({id: this.reminder.id, status: 'completed'}).then(() => this.$emit('updated', true));
      },

      handleDelete() {
        this.deleteReminder({id: this.reminder.id}).then(() => this.$emit('updated', true));
      }
    },

    mounted() {
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        this.form = {...this.reminder}
      })
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/Reminder/ReminderFormModal.vue